import { api, setCurrentAccessToken } from './rtkClient'
import { store } from './store'
import { logout } from './authUtils'


export const login = async (payload) => {
  try {
    const result = await store.dispatch(
      api.endpoints.loginUser.initiate(payload)
    ).unwrap()

    console.log('Login Result:', result)
    const token = result?.accessToken || result?.data?.token || result?.data?.data?.accessToken;
    if (token) setCurrentAccessToken(token)

    // Store user info if available - being more robust with structure
    const userData = result?.user || result?.data?.user || result?.data?.data?.user ||
      (result?.data?.username || result?.data?.email ? result.data : null) ||
      (result?.username || result?.email ? result : null);

    if (userData) {
      localStorage.setItem('user', JSON.stringify(userData));
    } else {
      // If no full user object, store at least the email/name if available elsewhere
      const fallbackName = result?.data?.data?.firstName || result?.data?.firstName || result?.firstName;
      if (fallbackName) {
        localStorage.setItem('user', JSON.stringify({ firstName: fallbackName }));
      }
    }

    return result
  } catch (error) {
    console.error('Login API Error:', error?.data || error?.message)
    throw error
  }
}


export const register = async (payload) => {
  try {
    const result = await store.dispatch(
      api.endpoints.registerUser.initiate(payload)
    ).unwrap()

    return result
  } catch (error) {
    console.error('Register API Error:', error?.data || error?.message)
    throw error
  }
}


export const getUserProfile = async (id) => {
  try {
    const result = await store.dispatch(
      api.endpoints.getUserProfile.initiate(id)
    ).unwrap()

    return result
  } catch (error) {
    console.error('Get Profile API Error:', error?.data || error?.message)
    throw error
  }
}


export const createTask = async (payload) => {
  try {
    const result = await store.dispatch(
      api.endpoints.createTask.initiate(payload)
    ).unwrap()

    return result
  } catch (error) {
    console.error('Create Task API Error:', error?.data || error?.message)
    throw error
  }
}

export const updateTask = async (payload) => {
  try {
    const result = await store.dispatch(
      api.endpoints.updateTask.initiate(payload)
    ).unwrap()

    return result
  } catch (error) {
    console.error('Update Task API Error:', error?.data || error?.message)
    throw error
  }
}

export const deleteTask = async (id) => {
  try {
    const result = await store.dispatch(
      api.endpoints.deleteTask.initiate(id)
    ).unwrap()

    return result
  } catch (error) {
    console.error('Delete Task API Error:', error?.data || error?.message)
    throw error
  }
}


export const getAllSprints = async () => {
  try {
    const result = await store.dispatch(
      api.endpoints.getAllSprints.initiate()
    ).unwrap()

    return result
  } catch (error) {
    console.error('Get All Sprints API Error:', error?.data || error?.message)
    throw error
  }
}


export const createSprint = async (payload) => {
  try {
    const result = await store.dispatch(
      api.endpoints.createSprint.initiate(payload)
    ).unwrap()

    return result
  } catch (error) {
    console.error('Create Sprint API Error:', error?.data || error?.message)
    throw error
  }
}